//size
export const SIZE_SMALL = 'sm';
export const SIZE_MEDIUM = 'md';
export const SIZE_LARGE = 'lg';

//backdrop
export const BACKDROP_STATIC = 'static';

//modal action
export const MODAL_ACTION_DELETE = 'Delete';
export const MODAL_ACTION_CANCEL = 'Cancel';

//warning
export const WARNING_LEVEL_DANGER = 'danger';
